import NextLink from 'next/link'
import clsx from 'clsx'
import { forwardRef } from 'react'
import { css } from '@emotion/react'
import { colorBack } from './Utility'
import config from '../../../config.json'

const Link = forwardRef(
    (
        {
            children,
            href,
            onMouseOver,
            onMouseOut,
            external = false,
            target,
            download,
            className,
            style,
            color,
            hoverColor,
            onClick,
            backgroundColor,
            rel,
            nextPrefetch = false,
            nextHrefAs = null,
            ...args
        },
        ref
    ) => {
        if (config.settings?.open_news_in_new_tab === true) target = '_blank'
        /* eslint-disable indent */
        const linkCss = (theme) => {
            return `
                color: ${colorBack(color) ||
                theme.colors?.[color] ||
                theme.colors?.medGray
                }; 
                ${backgroundColor
                    ? ''
                    : `&:hover {
                            color: ${colorBack(hoverColor) ||
                    theme.colors?.[hoverColor] ||
                    theme.colors?.primary
                    };
                        }`
                }   
                cursor: pointer;
                `
        }

        const bgLink = (theme) => {
            return `
                cursor: pointer;
                ${backgroundColor ?
                    `background-color: ${theme.colors?.[backgroundColor]}; 
                &:hover {
                        box-shadow: ${theme.boxShadow?.default};
                }` : ''}
                ${className}
            `
        }
        /* eslint-enable indent */

        const linkBody =
            external === true ? (
                <span className="external-link" css={bgLink}>
                    <a
                        href={href}
                        download={download}
                        target={target}
                        css={linkCss}
                        onClick={onClick}
                        onMouseOver={onMouseOver}
                        onMouseOut={onMouseOut}
                        ref={ref}
                        rel={rel}
                        {...args}
                    >
                        {children}
                    </a>
                </span>
            ) : (
                <span className="internal-link" css={bgLink}>
                    <NextLink href={href} passHref prefetch={nextPrefetch ? undefined : false} as={nextHrefAs}>
                        <a
                            onClick={onClick}
                            css={linkCss}
                            ref={ref}
                            onMouseOver={onMouseOver}
                            onMouseOut={onMouseOut}
                            rel={rel}
                            {...args}
                            target={target}
                        >
                            {children}
                        </a>
                    </NextLink>
                </span>
            )
        return (
            <div
                className={clsx('link inline-block', className)}
                css={css`
                    ${style}
                `}
            >
                {linkBody}
            </div>
        )
    }
)

export default Link
